import React from "react";

export default function ImageBox(props) {
  return (
<div className="lg:ml-4 mt-5 lg:mb-10 bg-gray-100 w-full md:w-[580px] overflow-hidden border-4">
  <img
    className="max-w-full max-h-full p-2"
    src={props.link}
    alt="Girl in a jacket"
  />
</div>
  );
}
